<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Annual Budget Form
                <div class="card-header-actions">
                    <button  :disabled="!saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
                <b-col md="6">
                <b-input-group>
                    <b-input-group-prepend><label>Department</label></b-input-group-prepend>
                    <b-form-input v-model="model.departemen" :state="!$v.model.departkd.$error" readonly></b-form-input>
                </b-input-group>
                </b-col>
                <b-col md="3">                            
                <b-input-group>
                    <b-input-group-prepend><label>Year Of</label></b-input-group-prepend>
                    <b-form-input v-model="model.tahun"  :state="!$v.model.tahun.$error" readonly></b-form-input>                                        
                </b-input-group>
                </b-col>
            </b-row >    
            <br>
            <div class="report-wraper table-responsive">
                    <table style="width: 100%;" class="">
                        <thead>
                            <tr>
                            <th width="100px">Account Code</th>
                            <th width="250px">Account Name</th>
                            <th style="text-align:right" width="120px">{{periode[0]}}</th>
                            <th style="text-align:right" width="120px">{{periode[1]}}</th>
                            <th style="text-align:right" width="120px">{{periode[2]}}</th>
                            <th style="text-align:right" width="120px">{{periode[3]}}</th>
                            <th style="text-align:right" width="120px">{{periode[4]}}</th>
                            <th style="text-align:right" width="120px">{{periode[5]}}</th>
                            <th style="text-align:right" width="120px">{{periode[6]}}</th>
                            <th style="text-align:right" width="120px">{{periode[7]}}</th>
                            <th style="text-align:right" width="120px">{{periode[8]}}</th>
                            <th style="text-align:right" width="120px">{{periode[9]}}</th>
                            <th style="text-align:right" width="120px">{{periode[10]}}</th>
                            <th style="text-align:right" width="120px">{{periode[11]}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in budgetLines" :key="row.kodeacc" >
                                <td v-if="(row.judul=='Y')" class="tebal">{{row.kodeacc}}</td>
                                <td v-else>{{row.kodeacc}}</td>
                                <td v-if="(row.judul=='Y')" class="tebal"><div style="width: 250px; overflow: hidden; display: inline-block; white-space: nowrap;"><span v-html="row.accname"></span></div></td>
                                <td v-else><div style="width: 250px; overflow: hidden; display: inline-block; white-space: nowrap;"><span v-html="row.accname"></span></div></td>
                                <td v-if="(row.judul=='Y')" class="tebal"></td>
                                <td v-else style="margin:0;padding:0;"><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;">
                                    <my-number v-model="row.budget1"  class="form-control text-right" style="border:none;" :precision="2"></my-number></div>
                                </td>
                                <td v-if="(row.judul=='Y')" class="tebal"></td>
                                <td v-else style="margin:0;padding:0;"><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;" >
                                    <my-number v-model="row.budget2"  class="form-control text-right"  style="border:none;" :precision="2" ></my-number></div></td>
                                <td v-if="(row.judul=='Y')" class="tebal"></td>
                                <td v-else style="margin:0;padding:0;" ><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;">
                                    <my-number v-model="row.budget3"  class="form-control text-right"  style="border:none;" :precision="2" ></my-number></div></td>
                                <td v-if="(row.judul=='Y')" class="tebal"></td>
                                <td v-else style="margin:0;padding:0"><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;">
                                    <my-number v-model="row.budget4"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></div></td>
                                <td v-if="(row.judul=='Y')" class="tebal"></td>
                                <td v-else style="margin:0;padding:0;"><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;">
                                    <my-number v-model="row.budget5"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></div></td>
                                <td v-if="(row.judul=='Y')" class="tebal"></td>
                                <td v-else style="margin:0;padding:0;" v-b-tooltip.hover :title="row.namaacc"><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;">
                                    <my-number v-model="row.budget6"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></div></td>
                                <td v-if="(row.judul=='Y')" class="tebal"></td>
                                <td v-else style="margin:0;padding:0;" v-b-tooltip.hover :title="row.namaacc"><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;">
                                    <my-number v-model="row.budget7"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></div></td>
                                <td v-if="(row.judul=='Y')" class="tebal"></td>
                                <td v-else style="margin:0;padding:0;" v-b-tooltip.hover :title="row.namaacc"><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;">
                                    <my-number v-model="row.budget8"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></div></td>
                                <td v-if="(row.judul=='Y')" class="tebal"></td>
                                <td v-else style="margin:0;padding:0;" v-b-tooltip.hover :title="row.namaacc"><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;">
                                    <my-number v-model="row.budget9"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></div></td>
                                <td v-if="(row.judul=='Y')" class="tebal"></td>
                                <td v-else style="margin:0;padding:0;" v-b-tooltip.hover :title="row.namaacc"><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;">
                                    <my-number v-model="row.budget10"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></div></td>
                                <td v-if="(row.judul=='Y')" class="tebal"></td>
                                <td v-else style="margin:0;padding:0;" v-b-tooltip.hover :title="row.namaacc"><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;">
                                    <my-number v-model="row.budget11"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></div></td>
                                <td v-if="(row.judul=='Y')" class="tebal"></td>
                                <td v-else style="margin:0;padding:0;" v-b-tooltip.hover :title="row.namaacc"><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;">
                                    <my-number v-model="row.budget12"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></div></td>
                            </tr>
                        </tbody>
                    </table>
            </div>                  
            <b-row class="justify-content-center mb-2">
                <button  :disabled="!saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    </div>    
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import budget_dept from "../../apis/budget_dept";
// import procure from "../../apis/procure";
// import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber},
  mixins: [validationMixin],
  validations: {
        model: {
            departkd: { required },
            departid: { required },
            tahun: { required }
        },
  }, 
  data() {
    return {
          isLoading:false,
        saveEnabled:true,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        awalbln:this.$store.state.user.awalbln || 1,
        periode:['Jan ','Feb ','Mar ','Apr ','May ','Jun ','Jul ','Aug ','Sep ','Oct ','Nov ','Dec '],
        uanguser: this.$store.state.user.matauang,
        model:{departid:'',tahun:'',departkd:''},
        budgetLines:[]    
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidOrdLines() {
      this.$v.ordLinesObj.$touch();
      return this.$v.ordLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function(){
    if (this.$route.params.departkd)  {
          toastr.info('Loading Budget, please wait')
          try {
            const data = await budget_dept.edit(this.$route.params);  
            const row = data[0][0];
            this.model.departid=row.departid;
            this.model.departkd=row.departkd;
            this.model.departemen=row.departkd +' | '+row.departemen;
            this.model.tahun=this.$route.params.tahun;
            this.budgetLines=data[1];
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
        let thn=parseInt(this.$route.params.tahun);
        let bln=parseInt(this.awalbln)-1;
        for (let index = 0; index < 12; index++) {
            bln += 1;
            if (bln>12) {
                thn += 1;
                bln = 1;
            }
            this.periode[index]=moment(`${thn}-${bln}-01`,'YYYY-MM-DD').format('MMM YYYY');
        }
        // if (this.$route.params.tahun>this.tahun) {
        //     this.saveEnabled=true;
        // }

    } 
  },
  methods: {
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.isLoading=true;
        this.saveEnabled=false;
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.isLoading=false;
            this.saveEnabled=true;
        } else {
            try {
                    const row = {};
                    row.departid=this.model.departid;
                    row.departkd=this.model.departkd;
                    row.tahun=this.model.tahun;
                    row.lines = this.budgetLines.reduce((newArr, item) => {
                        var total=item.budget1+item.budget2+item.budget3+item.budget4+item.budget5+item.budget6+item.budget7+item.budget8+item.budget9+item.budget10+item.budget11+item.budget12;
                        if ((item.judul === '') && (total != 0)) {
                            newArr.push({
                                tablekey: item.tablekey || '',
                                kodeacc: item.kodeacc,
                                budget1: item.budget1,
                                budget2: item.budget2,
                                budget3: item.budget3,
                                budget4: item.budget4,
                                budget5: item.budget5,
                                budget6: item.budget6,
                                budget7: item.budget7,
                                budget8: item.budget8,
                                budget9: item.budget9,
                                budget10: item.budget10,
                                budget11: item.budget11,
                                budget12: item.budget12
                            });
                        }
                        return newArr;
                    }, []);
                    if (row.lines.length>0) {
                        await budget_dept.save(row);
                        this.isLoading=false;
                        toastr.success("Complete successfully", "Save Budget");
                        this.close();
                    } else {
                        toastr.error('Please fill at least 1(one) Row', 'ERROR MESSAGE');
                        this.saveEnabled=true;
                        this.isLoading=false;
                    }
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;
            }

        }
    },
    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'procurement.receivingfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'budget.annualbudget'});
        //   router.push("home");
      }
    }
  }
};
</script>
